module.exports = __webpack_public_path__ + "static/media/Feb4-S19.05d57d6a.png";